import React, { useState, useEffect, useContext } from "react";

import { SearchDriver } from "@elastic/search-ui";

import { SearchContext } from "@elastic/react-search-ui";
import defaultA11yMessages from './A11yNotifications';
// import {defaultA11yMessages} from "@elastic/react-search-ui";
// import defaultA11yMessages from "./A11yNotifications";
import type { SearchDriverOptions } from "@elastic/search-ui";

export interface SearchProviderContextInterface {
  driver: SearchDriver;
}

type SearchProviderProps = {
  children: React.ReactNode;
  config: SearchDriverOptions;
  // driver?: SearchDriver;
  initialConnector?: any;
  initialData?: any;
};

const Provider = SearchContext.Provider;

/**
 * The SearchProvider primarily holds a reference to the SearchDriver and
 * exposes it to the rest of the application in a Context.
 */
const OurSearchProvider = ({
  children,
  config,
  // driver,
  initialData = null,
}: SearchProviderProps): JSX.Element => {

  const initialDriver = initialData ? new SearchDriver({
    ...config,
    alwaysSearchOnInitialLoad: false,
    // SAM TODO HERE
    trackUrlState: true,
    a11yNotificationMessages: {
      ...defaultA11yMessages,
      ...config.a11yNotificationMessages
    }
  }) : null;

  if (initialDriver && initialData) {
    initialDriver._setState(initialData);
  }
  const [driverInstance, setDriverInstance] = useState<SearchDriver>(initialDriver);

  useEffect(() => {
    if (driverInstance) return () => {
      driverInstance.tearDown();
    };
    // This initialization is done inside of useEffect, because initializing the SearchDriver server side
    // will error out, since the driver depends on window. Placing the initialization inside of useEffect
    // assures that it won't attempt to initialize server side.
    const currentDriver =
      // driver ||
      new SearchDriver({
        ...config,
        trackUrlState: true,

        a11yNotificationMessages: {
          ...defaultA11yMessages,
          ...config.a11yNotificationMessages
        }
      });
    setDriverInstance(currentDriver);

    return () => {
      currentDriver.tearDown();
    };
  }, []);

  // This effect allows users to dynamically update their searchQuery without re-mounting a SearchProvider,
  // which would be destructive. An example of why this is useful is dynamically updating facets.
  // useEffect(() => {
  //   if (driverInstance) {
  //     // driverInstance.setSearchQuery(config.searchQuery);
  //   }
  // }, [config.searchQuery]);

  // useEffect(() => {
  //   if (driverInstance) {
  //     driverInstance.setAutocompleteQuery(config.autocompleteQuery);
  //   }
  // }, [config.autocompleteQuery]);

  // Since driver is initialized in useEffect above, we are waiting
  // to render until the driver is available.
  if (!driverInstance) return null;

  // Passing the entire "this.state" to the Context is significant. Because
  // Context determines when to re-render based on referential identity
  // something like this could cause unnecessary renders:
  //
  // <SearchContext.Provider value={{driver: this.state.driver}}>
  //
  // By passing the entire state, we ensure that re-renders only occur when
  // state is actually updated.

  const contextValue: SearchProviderContextInterface = {
    driver: driverInstance
  };

  return React.createElement(SearchContext.Provider, { value: contextValue}, children);
};

export default OurSearchProvider;
